import { DeepPartial, FieldValues } from 'react-hook-form'
import ImageUploadField from '../forms/ImageUploadField'
import SingleLineField from '../forms/SingleLineField'
import FormModal from './FormModal'
import { Switch } from '../lists/listComponents/Switch'
import FormItem from '../forms/utils/FormItem'

interface EditorImageModalProps<T extends FieldValues> {
    open: boolean,
    defaultValues: DeepPartial<T>,
    onOk: (values: T) => void,
    onCancel: () => void
}

export default function EditorImageModal<T extends FieldValues>(props: EditorImageModalProps<T>) {
    const editMode = props.defaultValues !== undefined

    return (
        <FormModal {...props}
            title={editMode ? 'Edit Image' : 'Add Image'}
            okText={editMode ? 'Edit Image' : 'Add Image'}
        >
            <ImageUploadField name='publicId' label='Image' top />
            {/* @ts-ignore */}
            <SingleLineField
                label={"Alt"}
                top={true}
                htmlfor="alt" />
            {/* @ts-ignore */}
            <SingleLineField
                label={"Title"}
                top={true}
                htmlfor="title" />
            <FormItem label='Interscroller'>
              <Switch name="interscroller" />
            </FormItem>
        </FormModal>
    )
}
